export default __webpack_public_path__ + "static/susan-schmidt-portrait-f82acd309f8b31214c137dcc538e2f7c.webp";